import { useState, useEffect } from "react";
import axios from "axios";
//locall
import { storage } from "./storage";

const useRequest = ({
  method,
  url,
  repeat = false,
  body,
  navigation,
  isFunction = false,
  token = true,
}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (repeat) {
      setLoading(true);
      storage
        .load("token")
        .then(async (res) => {
          if (!res) {
            return Promise.reject();
          }

          await axios({
            method: method,
            url: url,
            headers: {
              "x-auth": res,
            },
            data: body,
          })
            .then((axiosRes) => {
              if (
                axiosRes.data.message ===
                  "Token not valid or user not found." ||
                axiosRes.data.message === "Token not valid."
              ) {
                setLoading(false);
                setError("Token not valid.");
                storage.remove("token");
                navigation.navigate("GetPhoneNumber");
              } else {
                setLoading(false);
                setData(axiosRes.data);
              }
            })
            .catch((err) => {
              setLoading(false);
              setError(err.response);
            });
        })
        .catch((err) => {
          setLoading(false);
          setError(err.response);
        });
      const interval = setInterval(() => {
        setLoading(true);
        storage
          .load("token")
          .then(async (res) => {
            if (!res) {
              return Promise.reject();
            }

            await axios({
              method: method,
              url: url,
              headers: {
                "x-auth": res,
              },
              data: body,
            })
              .then((axiosRes) => {
                if (
                  axiosRes.data.message ===
                    "Token not valid or user not found." ||
                  axiosRes.data.message === "Token not valid."
                ) {
                  setLoading(false);
                  setError("Token not valid.");
                  storage.remove("token");
                  navigation.navigate("GetPhoneNumber");
                } else {
                  setLoading(false);
                  setData(axiosRes.data);
                }
              })
              .catch((err) => {
                setLoading(false);
                setError(err.response);
              });
          })
          .catch((err) => {
            setLoading(false);
            setError(err.response);
          });
      }, 3000);
      return () => clearInterval(interval);
    } else {
      if (!isFunction) {
        if (token) {
          setLoading(true);
          storage
            .load("token")
            .then((res) => {
              if (!res) {
                return Promise.reject();
              }
              console.log(res);
              axios({
                method: method,
                url: url,
                headers: {
                  "x-auth": res,
                },
                data: body,
              })
                .then((axiosRes) => {
                  if (
                    axiosRes.data.message ===
                      "Token not valid or user not found." ||
                    axiosRes.data.message === "Token not valid."
                  ) {
                    setLoading(false);
                    setError("Token not valid.");
                    storage.remove("token");
                    navigation.navigate("GetPhoneNumber");
                  } else {
                    setLoading(false);
                    setData(axiosRes.data);
                  }
                })
                .catch((err) => {
                  setLoading(false);
                  setError(err.response);
                });
            })
            .catch((err) => {
              setLoading(false);
              setError(err.response);
            });
        } else {
          setLoading(true);

          axios({
            method: method,
            url: url,
            data: body,
          })
            .then((axiosRes) => {
              if (!axiosRes) Promise.reject();
              setLoading(false);
              setData(axiosRes.data);
            })
            .catch((err) => {
              setLoading(false);
              setError(err.response);
            });
        }
      }
    }
  }, []);

  const requestF = (myData) => {
    return token
      ? new Promise((resolve, reject) => {
          setLoading(true);
          storage
            .load("token")
            .then((res) => {
              if (!res) {
                return Promise.reject();
              }

              axios({
                method: method,
                url: url,
                headers: {
                  "x-auth": res,
                },
                data: myData ? myData : body,
              })
                .then((axiosRes) => {
                  if (
                    axiosRes.data.message ===
                      "Token not valid or user not found." ||
                    axiosRes.data.message === "Token not valid."
                  ) {
                    setLoading(false);
                    setError("Token not valid.");
                    reject(new Error("Token not valid"));
                    storage.remove("token");
                    navigation.navigate("GetPhoneNumber");
                  } else {
                    setLoading(false);
                    setData(axiosRes.data);
                    resolve(axiosRes.data);
                  }
                })
                .catch((err) => {
                  setLoading(false);
                  reject(err.response);
                  setError(err.response);
                });
            })
            .catch((err) => {
              setLoading(false);
              reject(err.response);
              setError(err.response);
            });
        })
      : new Promise((resolve, reject) => {
          setLoading(true);
          console.log(body);
          axios({
            method: method,
            url: url,
            data: myData ? myData : body,
          })
            .then((axiosRes) => {
              if (!axiosRes) {
                Promise.reject();
              } else {
                setLoading(false);
                setData(axiosRes.data);
                resolve(axiosRes.data);
              }
            })
            .catch((err) => {
              setLoading(false);
              setError(err);
              reject(err);
            });
        });
  };

  const clearData = () => setData(null);

  return [error, loading, data, requestF, clearData];
};

export { useRequest };
